export default __webpack_public_path__ + "static/media/downloadicon.07452fe3.svg";